const Language = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 8.5a.5.5 0 0 1 .464.314l3.6 9a.5.5 0 1 1-.928.372L18.06 15.5h-4.123l-1.074 2.686a.5.5 0 1 1-.928-.372l3.6-9A.5.5 0 0 1 16 8.5m-1.662 6L16 10.346l1.662 4.154zM9.5 4.5a.5.5 0 0 1 .5.5v1h4a.5.5 0 0 1 0 1h-.655c-.74 1.889-1.644 3.255-2.786 4.51.49.382 1.05.735 1.665 1.043a.5.5 0 1 1-.448.894 11 11 0 0 1-1.912-1.212c-.864.859-1.852 1.703-2.986 2.672l-.553.473a.5.5 0 1 1-.65-.76l.511-.437c1.135-.97 2.098-1.795 2.927-2.613-.749-.741-1.305-1.566-1.587-2.412a.5.5 0 1 1 .948-.316c.224.67.684 1.363 1.334 2.009A12.8 12.8 0 0 0 12.266 7H5a.5.5 0 0 1 0-1h4V5a.5.5 0 0 1 .5-.5"
      clipRule="evenodd"
    />
  </>
)
export default Language
